import {Injectable,Inject} from 'ng-metadata/core';
import {ConfigurationUtil} from "../../../../../../nddUtils/configurationUtil.service";


@Injectable()
export class LocationService{

    
    constructor(private configurationUtil: ConfigurationUtil,
                @Inject('$translate')  private $translate:ng.translate.ITranslateService) {
        this.configurationUtil = configurationUtil;
    }


	public isOvpLocation(location){
       
        let holdingURL = location.holdingURL;
        if (!location.holdingURL) {
           /* PRM-33057 New UI - Location from other institution is not displayed
           Somehow there is a 'location' key in the 'location' JSON
           If so, we get the location from here
           */
            if (location.location) {
                holdingURL = location.location.holdingURL;
            }
        }
        
		return !holdingURL || holdingURL.toUpperCase() === 'OVP' 
	}

    public isSuprima(){
        return (this.configurationUtil.getBackendSystem() === 'suprima');
    }
    public getLibraryName(location){
        if (location && location.librarycodeTranslation){
            return location.librarycodeTranslation;
        }
        let lib =  location.libraryCode || '';
        let instCode = location.organization;
        let code = instCode+'.library.'+lib;
        if(this.isSuprima()){
            location.librarycodeTranslation = location.mainLocation || location['main-location'];
            return location.librarycodeTranslation;
        }else{
            this.$translate(code,[],'', this.$translate.instant(lib)).then(
               translation=> {
                  location.librarycodeTranslation = translation;
               });
        }
    }


    public getSubLibraryName(location){
        if (location && location.collectionTranslation){
            return location.collectionTranslation;
        }
        let subLocation =  location.subLocation || '';
        let instCode = location.organization;
        let code = instCode+'.collection.'+subLocation;
        if(this.isSuprima()){
            // No need to translate location, it comes translated from the server
            location.collectionTranslation = subLocation;
        } else {
            let transletedSubCollection = subLocation.indexOf('.') > -1 ? subLocation : this.$translate.instant(subLocation);
            this.$translate(code,[],'', transletedSubCollection).then(
                translation=> {
    
                    location.collectionTranslation = translation;
                });
        }

    }

}


//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/locations/location/location.service.ts